import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContactDetails from "./ContactDetails.jsx";
import { getEnv } from "../../env.js";

export default function ContactModal({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Kontakt
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <ContactDetails
          label={getEnv("VITE_TENANT_LABEL")}
          label_name={getEnv("VITE_TENANT_LABEL2")}
          label_funktion={getEnv("VITE_TENANT_FUNKTION")}
          kontakt={{
            items: [
              { typ: "Telefon", nummer: getEnv("VITE_TENANT_TELEFON") },
              { typ: "Telefax", nummer: getEnv("VITE_TENANT_FAX") },
              { typ: "E-Mail", nummer: getEnv("VITE_TENANT_EMAIL") },
            ],
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
